import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountRegisterConfirm implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountRegisterConfirmContainer";
    }
    render(){
        // console.log("register");
        const timezoneField = document.getElementById("user_timezone") as HTMLSelectElement;
        if(timezoneField.selectedIndex==0) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            for (let i = 0; i < timezoneField.options.length; i++) {
                if (timezoneField.options[i].value === timezone) {
                    timezoneField.selectedIndex = i;
                    break;
                }
            }
        }
    }
}